<template>
  <div>
    <v-form ref="form" flat class="pa-6" v-model="valid" lazy-validation>
      <v-row cols="12">
        <v-col>
          <h3>1. Thông tin cơ bản</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" v-if="$route.name === 'head-fees'">
          <v-autocomplete
            v-model="headFeeCollection"
            clear-icon="mdi-close"
            :items="collections"
            item-text="title"
            item-value="id"
            label="Nhóm"
            :loading="loading"
            clearable
            outlined
            dense
            return-object
            required
            class="required font-size"
            :rules="[$rules.required]"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="title"
            :label="$route.meta.title"
            :placeholder="$route.meta.title"
            outlined
            required
            dense
            class="required font-size"
            :rules="[$rules.required]"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" v-if="$route.name === 'head-fees'">
          <v-autocomplete
            v-model="kind"
            clear-icon="mdi-close"
            :items="kinds"
            item-text="text"
            item-value="value"
            label="Loại hoá đơn"
            clearable
            outlined
            dense
            return-object
            required
            class="required font-size"
            :rules="[$rules.required]"
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row v-if="$route.name !== 'head-fees'">
        <v-col cols="6">
          <v-autocomplete
            v-model="headFeeApply"
            clear-icon="mdi-close"
            :items="headFees"
            item-text="title"
            item-value="id"
            label="Áp dụng với khoản phí thu/đóng"
            :loading="loading"
            clearable
            outlined
            dense
            return-object
            required
            class="required font-size"
            :rules="[$rules.required]"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="headFeeCollection.title"
            label="Nhóm"
            outlined
            required
            dense
            class="required font-size"
            disabled
            :rules="[$rules.required]"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row cols="12">
        <v-col cols="12">
          <v-textarea v-model="note" outlined dense name="input-7-3" label="Ghi chú" rows="3"></v-textarea>
        </v-col>
      </v-row>
      <div>
        <v-row cols="12">
          <v-col>
            <h3>2. Thông tin hiển thị</h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="shortName"
              label="Tên hiển thị ngắn"
              placeholder="Tên sẽ được hiển thị tại Chi tiết hoá đơn"
              outlined
              dense
              hide-details="auto"
              class="font-size"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="rank"
              label="Ưu tiên hiển thị"
              placeholder="Thứ tự hiển thị tại Chi tiết hoá đơn"
              outlined
              dense
              class="font-size"
              :rules="[$rules.isNumber]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="subNote"
              outlined
              dense
              name="input-7-3"
              label="Ghi chú hiển thị"
              placeholder="Ghi chú sẽ được hiển thị tại Chi tiết hoá đơn"
            ></v-textarea>
          </v-col>
        </v-row>
      </div>
    </v-form>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  data() {
    return {
      title: '',
      category: 'custom',
      note: '',
      tags: '',
      headFeeApply: '',
      rank: '',
      shortName: '',
      valid: true,
      subNote: '',
      headFeeCollection: '',
      headFees: [],
      loading: false,
      kind: {},
      kinds: [
        {
          text: 'Học phí',
          value: 'cen',
        },
        {
          text: 'Thu hộ, chi hộ',
          value: 'decen',
        },
      ],
    }
  },
  async created() {
    this.loading = true
    this.headFees = await this.fetchHeadFees({ type: 'normal', isSubFee: 'false' })
    this.fetchCollections()
    this.loading = false
  },
  computed: {
    ...mapState('tuitonFeeHeadFee', ['router', 'isSubFee']),
    ...mapState('tuitionFeeCollection', ['collections']),
    titleType() {
      return this.$route.meta.title.replace('tên khoản', '')
    },
  },
  methods: {
    ...mapActions('tuitonFeeHeadFee', ['fetchHeadFees']),
    ...mapActions('tuitionFeeCollection', ['fetchCollections']),
    reset() {
      this.$refs.form.reset()
    },
    validate() {
      return this.$refs.form.validate()
    },
    getData() {
      if (this.validate()) {
        let kind = ''
        if (this.$route.name === 'head-fees') kind = this.kind.value
        if (this.$route.name !== 'head-fees') kind = this.headFeeApply.kind
        return {
          title: this.title,
          category: this.category,
          note: this.note,
          type: this.router,
          kind,
          head_fee_apply: this.headFeeApply && this.headFeeApply.id,
          head_fee_collection: this.headFeeCollection && this.headFeeCollection.id,
          tags: this.title
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, ''),
          rank: +this.rank,
          metadata: { shortName: this.shortName, subNote: this.subNote },
          isSubFee: this.isSubFee,
        }
      }
    },
  },
  watch: {
    headFeeApply() {
      this.headFeeCollection = this.headFeeApply ? this.headFeeApply.head_fee_collection : ''
    },
    async router() {
      if (this.router === 'priority') {
        this.headFees = await this.fetchHeadFees({ type: 'normal', isSubFee: 'false' })
        this.fetchCollections()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
h3 {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #212121;
}
.font-size {
  font-size: 14px;
}
</style>
